module.exports = __webpack_public_path__ + "img/c_4_2.a383828f.png";